export default "__VITE_ASSET__WgXm_tRn__"